import {computed, defineComponent} from 'vue'

export default defineComponent({
    compatConfig: {
        MODE: 3
    },
    name: 'KlOlMapLoader',
    props: {
        tagName: {
            type: String,
            default: 'div'
        },
        modOverlay: Boolean,
        modBlocking: Boolean,
        title: {
            type: String,
            default: ''
        }
    },
    setup(props) {
        const classes = computed(() => {
            return [
                'kl-ol-map-loader',
                {
                    'kl-ol-map-loader--blocking': props.modBlocking,
                    'kl-ol-map-loader--overlay': props.modOverlay
                }
            ]
        })

        return {
            classes
        }
    }
})
